// Dev default stays :5000 (bare `flask run`). Override via REACT_APP_BACKEND_URL
// in .env.local — needed for the compose stack, which publishes :8000, and on
// macOS, where AirPlay Receiver squats on :5000 and answers 403.
export const backendURL =
  process.env.NODE_ENV !== "production"
    ? process.env.REACT_APP_BACKEND_URL ?? "http://127.0.0.1:5000"
    : process.env.REACT_APP_BACKEND_URL ?? "";

export const config = {
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    Accept: "*/*",
  },
};

export const Backend_Urls = {
  // auth urls
  login_url: "/api/login",
  logout_url: "/api/logout",
  reset_password_link_url: "/api/reset_password_link",
  reset_password_url: "/api/reset_password",
  refresh_token_url: "/api/refresh",
  generate_otp: "/api/generate_otp",
  verify_otp: "/api/verify_otp",

  // administration url
  admin_url: "/api/administrator",

  users_url: "/api/users",
  update_user_url: "/api/update_user",
  disable_user_url: "/api/delete_user",
  enable_user_url: "/api/enable_user",

  account_management: "/api/account_management",

  clients_url: "/api/clients",
  update_client_url: "/api/update_client",
  disable_client_url: "/api/delete_client",
  enable_client_url: "/api/enable_client",

  roles_url: "/api/roles",

  products_url: "/api/products",
  update_product_url: "/api/update_product",
  delete_product_url: "/api/delete_product",
  enable_product_url: "/api/enable_product",

  programs_url: "/api/programs",
  plans_url: "/api/plans",
  client_plan_url: "/api/client_plan",
  client_type_url: "/api/client_type",


  attach_subscription_url: "/api/attach_subscription",


  marketing_cost: "/api/marketing_cost",

  client_user_title: "/api/client_user_title",

  email_notification_url: "/api/email_notification",

  ///////////////////
  // Single endpoints
  ///////////////////

  // One-call aggregate of the analytics sections a portal tab renders
  // (POST {tabs: [...]}; sections shape-identical to the standalone endpoints)
  dashboard_aggregate: "/api/dashboard_aggregate",

  // Get all branches and departments
  branches_and_departments: "/api/get_branches_and_departments",

  // Get last updated
  last_updated: "/api/get_last_updated",

  // Landing Page
  growth_score: "/api/get_growth_score",
  retention: "/api/get_retention",
  g_reviews: "/api/get_g_reviews",
  nps_score: "/api/get_nps_score",
  nps_survey: "/api/get_nps_survey",
  industries: "/api/get_industries",
  purchase: "/api/get_purchase",
  retention_leads: "/api/get_retention_leads",
  prospect_verified: "/api/get_prospect_verified",
  get_email_reports: "/api/get_email_reports",

  // Growth and Forecast
  growth_rate: "/api/get_growth_rate",
  growth_rate_detail: "/api/get_growth_rate_detail",
  growth_rate_benchmark: "/api/get_growth_rate_benchmark",
  forecast_detail: "/api/get_forecast_detail",
  atrisk: "/api/get_atrisk",
  atrisk_detail: "/api/get_atrisk_detail",
  wgs: "/api/get_wgs",
  wgs_detail: "/api/get_wgs_detail",

  // Retention
  ggd_rating: "/api/get_ggd_rating",
  ggd_rating_detail: "/api/get_ggd_rating_detail",
  net_promoter: "/api/get_net_promoter",
  customer_survey: "/api/get_customer_survey",
  customer_survey_detail: "/api/get_customer_survey_detail",
  retention_rate: "/api/get_retention_rate",

  // Transactions
  branch_transactions: "/api/get_branch_transactions",
  industry_by_revenue: "/api/get_industry_by_revenue",
  industry_by_revenue_detail: "/api/get_industry_by_revenue_detail",
  purchase_distribution: "/api/get_purchase_distribution",
  distribution_transaction_revenue: "/api/get_distribution_transaction_revenue",
  product_analysis_detail: "/api/get_product_analysis_detail",

  // Leads
  last_purchase_cust_leads: "/api/get_last_purchase_cust_leads",
  last_purchase_detail: "/api/get_last_purchase_detail",
  prospect_leads_reports: "/api/get_prospect_leads_reports",
  prospect_leads_reports_detail: "/api/get_prospect_leads_reports_detail",
  gain_and_lost_accounts: "/api/get_gain_and_lost_accounts",

  // Sales Rep
  rank_by_email: "/api/get_rank_by_email",
  rank_by_retention: "/api/get_rank_by_retention",
  rank_by_stable_account: "/api/get_rank_by_stable_account",
  rank_by_wgs: "/api/get_rank_by_wgs",
  rank_by_wgs_detail: "/api/get_rank_by_wgs_detail",

  // Marketing
  market_by_customer: "/api/get_market_by_customer",
  market_overview: "/api/get_market_overview",
  product_by_cust_count: "/api/get_product_by_cust_count",
  product_by_revenue: "/api/get_product_by_revenue",
  associated_product: "/api/get_associated_product",

  // Financial
  // balance_sheet: '/api/get_balance_sheet',
  // balance_sheet_2: '/api/get_balance_sheet_2',
  forecast_revenue_plan: "/api/forecast_revenue_plan",
  // income_statement: '/api/get_income_statement',
  // income_statement_kpi: '/api/get_income_statement_kpi'

  // branch ranking
  get_branch_rank_by_email: "/api/get_branch_rank_by_email",
  get_branch_rank_by_retention: "/api/get_branch_rank_by_retention",
  get_branch_rank_by_stable: "/api/get_branch_rank_by_stable",

  employee_course: "/api/employee_course",
  employee_module: "/api/employee_module",
  employee_module_summary: "/api/employee_module_summary",

  programs: "/api/programs",
  client_programs: "/api/client_programs",
  client_salesmen: "/api/client_salesmen",


  client_salesmen_data: "/api/client_salesmen_data",

  training_users: "/api/training_users",
  training_roles: "/api/training_roles",
  training_schools: "/api/training_schools",
  training_domains: "/api/training_domains",
  user_table_settings: "/api/user_table_settings",

  all_client_salesmen: "/api/all_client_salesmen",
  deactivate_sales_rep: "/api/deactivate_sales_rep",
  activate_sales_rep: "/api/activate_sales_rep",


  get_client_admin: "/api/client_admin",
  update_client_admin_notification: "/api/update_client_admin_notification",
  update_client_notification: "/api/update_client_notification",
};
